module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_f_normal.ca15f13a.png";